var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { name as CookieJobStorageDriverName } from './cookieJobStorageDriver';
import { QOSSubscriptionEvents } from './jobSubscriber';
/** Custom event that our subscriber will be listening to */
const createJobEvent = (job) => new CustomEvent(job.getTopic(), { detail: { job } });
/** Name of this module */
export const name = 'JobDispatcher';
let JobDispatcher = class JobDispatcher {
    constructor(jobStorage) {
        this.jobStorage = jobStorage;
        document.addEventListener(QOSSubscriptionEvents.QOS1, this.dispatchJobsForTopic.bind(this));
    }
    /**
     * Dispatch a specific job
     * @param job The job we want to dispatch
     */
    dispatchJob(job) {
        document.dispatchEvent(createJobEvent(job));
        // Increment the times this job has been played
        job.addPlay();
        if (job.isDurable()) {
            this.jobStorage.persistJob(job);
        }
    }
    /**
     * Dispatches all jobs for a topic in the job queue
     */
    async dispatchJobsForTopic(event) {
        const { topic } = event.detail;
        this.jobStorage
            .retrieveJobsByTopic(topic)
            .forEach(this.handleJob.bind(this));
    }
    /**
     * Handles an individual job and it's steps
     */
    handleJob(job) {
        if (!job.isPlayable()) {
            return;
        }
        // Dispatch our custom event
        document.dispatchEvent(createJobEvent(job));
        // Increment the times this job has been played
        job.addPlay();
        if (job.isDurable()) {
            this.jobStorage.persistJob(job);
        }
    }
};
JobDispatcher = __decorate([
    injectable({
        key: name,
        scope: InjectorScope.Singleton,
        dependencies: {
            ...Injector.createDependency(CookieJobStorageDriverName, InjectorScope.Singleton),
        },
    })
], JobDispatcher);
export default JobDispatcher;
